import '../../styles/ButtonFiltered.css';

const FilteredButtons = ({ items, selectedValue, setSelected }) => (
    <div className="btn_filter_wine">
        {items.map((item, index) =>
            <button
                key={index}
                onClick={() => setSelected(item.value)}
                className={item.value === selectedValue ? "btn_millesime_selected" : "btn_millesime"}
            >
                   {item.icon && <span style={{ marginRight: '0.5rem' }}>{item.icon}</span>}
        {item.label}
              
            </button>
        )}

    </div>
);

export default FilteredButtons;